import { createFileRoute } from '@tanstack/react-router';

import { BriefBatchView } from 'src/sections/white-glove/briefs/brief-batch-view';

/**
 * The briefs on the plan, optionally narrowed to one planned batch.
 *
 * The search shape is the server's: the "we planned N emails" notification
 * links to `briefs?batch=<planId>`, so it lands here without anything having to
 * rewrite the URL. Without a batch the page shows everything planned from today.
 */
type BriefsSearch = {
  batch?: string;
};

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove/briefs')({
  validateSearch: (search: Record<string, unknown>): BriefsSearch => ({
    batch: typeof search.batch === 'string' ? search.batch : undefined,
  }),
  component: WgBriefsPage,
});

function WgBriefsPage() {
  const { batch } = Route.useSearch();
  return <BriefBatchView planId={batch} />;
}
